import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { Breadcrumb } from '@/components/Breadcrumb'
import { StyledActionButton } from '@/components/Buttons'
import { FormStyled, FormSubmit } from '@/components/templates/Form'
import { ScrollableContent } from '@/components/templates/ScreenLayout'
import { ScreenWrapper } from '@/components/templates/ScreenWrapper'
import { Subheader } from '@/components/Text'
import { useTrackFormProgress } from '@/hooks/useTrackFormProgress'
import { getBMIThreshold } from '@/utils/showBMIForCategory'
import { VelthuisFormStep } from '@/utils/VelthuisFormSteps'

import * as S from './BMIHigh.styled'

const VELTHUIS_PHONE_NUMBER = '088 - 778 52 01'

export const BMIHigh = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'bmiHigh',
  })
  const navigate = useNavigate()
  const { appointmentType, bmi: bmiParam, category } = useParams()

  const bmi = parseFloat(bmiParam ?? '0')

  const { trackFormInteraction } = useTrackFormProgress(
    VelthuisFormStep.BMIHigh,
    { complete: true },
  )

  const bmiThreshold =
    appointmentType && category
      ? (getBMIThreshold(appointmentType, category) ?? 30)
      : 30

  const handleGoBack = () => {
    navigate(-1)
    trackFormInteraction({
      action: 'previous',
      formFieldName: 'back-to-previous',
    })
  }

  const handlePhoneCall = () => {
    trackFormInteraction({
      action: 'click',
      formFieldName: 'call-us-button',
    })
    window.location.href = `tel:${VELTHUIS_PHONE_NUMBER}`
  }

  return (
    <ScreenWrapper>
      <Breadcrumb onClick={handleGoBack} title={t('breadcrumbLink')} />

      <FormStyled method="post">
        <ScrollableContent>
          <S.ContentWrapper>
            <S.WarningIconWrapper>
              <S.WarningIcon />
            </S.WarningIconWrapper>

            <S.TextContent>
              <Subheader>{t('header')}</Subheader>

              <S.BmiValue>
                {t('yourBmi')} {bmi ? bmi.toFixed(1) : '0.0'}
              </S.BmiValue>

              <S.Paragraph>{t('thresholdInfo', { bmiThreshold })}</S.Paragraph>
              <S.Paragraph>{t('partnerInfo')}</S.Paragraph>

              <S.Paragraph>
                {t('contactInfo')}{' '}
                <S.PhoneLink href={`tel:${VELTHUIS_PHONE_NUMBER}`}>
                  {VELTHUIS_PHONE_NUMBER}
                </S.PhoneLink>
                {'.'}
              </S.Paragraph>
              <S.Paragraph>{t('specialistInfo')}</S.Paragraph>

              <S.HoursContainer>
                <S.HoursTitle>{t('availableHours.title')}</S.HoursTitle>
                <S.HoursText>
                  {t('availableHours.mondayToThursday')}
                </S.HoursText>
                <S.HoursText>{t('availableHours.friday')}</S.HoursText>
              </S.HoursContainer>
            </S.TextContent>
          </S.ContentWrapper>
        </ScrollableContent>

        <FormSubmit>
          <StyledActionButton
            variant="Primary"
            type="button"
            onClick={handlePhoneCall}
          >
            {t('actions.callUs')}
          </StyledActionButton>
        </FormSubmit>
      </FormStyled>
    </ScreenWrapper>
  )
}
